const validator = function(selector, test)
{
  
 
  
  if(typeof selector == 'object') {
    var form = selector;
  } else {
    var form = document.querySelector(selector);
  }

  
  for (let key in test) {

    if(!!~key.indexOf('[]')) {
      key = key.replace('[]', '')
      let fields = form.querySelectorAll(`[name*=${key}]`);
      requiredAll(fields);
      return;
    }
    
    let field = form.querySelector(`[name=${key}]`);
    for (var keyy in test[key]) {
      field.addEventListener('input', eval(keyy))
    }
  }
  
    
  
  function compare() {
    let field = form.querySelector(`[name=${test[this.name].compare.field}]`);
    let status = this.value === field.value;

    showError.call(this, !status, test[this.name].compare.message)

    allow(status);
    
    
  }
  function regexp() {
    let status  = test[this.name].regexp.regexp.test(this.value);
    showError.call(this, !status, test[this.name].regexp.message )
    allow(status);
  }

  function requiredAll(fields) {



    form.addEventListener('submit', function(e){
      //e.preventDefault();
      
      let i = 0;
      fields.forEach(el => {
        if(el.checked) i++;
      });

      if(i===0) {
        e.preventDefault();
      }
      
      
      showError.call(fields[fields.length-1], i === 0, test[fields[0].name].requiredAll.message )

      //allow(i !== 0);
      
      
    })
  }

  function showError(status, message) {
    
    if(this.type === 'checkbox') {
      let parent = this.parentElement.parentElement.parentElement;
      
      status ? parent.classList.add('is-error')
            : parent.classList.remove('is-error');
      parent.lastElementChild.innerText = message;
      return;
    } else {
      let parent = this.parentElement;
      status ? parent.classList.add('input--error')
             : parent.classList.remove('input--error');

      if(!this.nextElementSibling) {
        let span = document.createElement('span');
        span.className = 'input__error';
        this.parentElement.appendChild(span);
      }
      this.nextElementSibling.innerText = message;
      
    }
    
    
  }

  function allow(isAllow) {
    let btn = form.querySelector('button[type="submit"]');
    btn.disabled = !isAllow;
  }
  
}

export default validator